import React, { useState } from "react";
import { Button } from "../../Components";
import { subStatusData } from "../data/data";
import Header from "../commonComponent/Header";
import queryString from "query-string";
import { useNavigate } from "react-router-dom";
import { countryCode } from "../config/wapConfig";
import { Base64 } from 'js-base64';

function SubStatus() {

  const navigate = useNavigate();
  const { id, type } = queryString.parse(window.location.search)
  // id = parseInt(id)
  console.log("id ::", id)
  const data = subStatusData.find((item) => item.type == type);
  const msisdn = localStorage.getItem("msisdn")
  const uid = `m=${countryCode.substring(1) + msisdn}`;

  const handleButton = () => {
    if (id == 7 || id == 6 || type == 'plan_upgrade' || type == "subscribe") {
      navigate(`/home?uid=${Base64.encode(uid)}`)
    }
    else {
      navigate(-1)
    }
  };

  return (
    <div className="bg-darkPurple flex flex-col h-screen">
      <Header />
      <div className="flex-grow mt-32">
        <div className="mt-2 flex text-center flex-col items-center text-white">
          <img className="h-20 w-20 rounded-full mb-2 mt-12" src={data?.icon} />
          <div className="font-semibold text-2xl my-4">{data?.heading}</div>

          {
            type == "subscribe" && sessionStorage.getItem("isAlreadyActive") === "isAlreadyActive" ?
              <>
                <div className="w-80 my-2">{'مرحبًا بعودتك'}</div>
                <div className="w-80 text-buttonYellow">{'اضغط على الزر لتسجيل الدخول الآن'}</div>
              </>
              :
              type == "subscribe" ?
                <>
                  <div className="w-80 my-2">{'أنت مشترك.'}</div>
                  <div className="w-80 text-buttonYellow">{'اضغط على الزر لتسجيل الدخول الآن'}</div>
                </>
                :
                <>
                  <div className="w-80 my-2">{data?.text1}</div>
                  {data?.text2 && <div className="w-80 text-buttonYellow">{data?.text2}</div>}
                </>
          }

          <Button
            name={data?.btn}
            handleClick={handleButton}
            className="h-12 bg-buttonYellow mt-8 rounded-full font-bold  text-darkPurple text-xl w-80"
          />
        </div>
      </div>
    </div>
  );
}

export default SubStatus;
